// extracted by mini-css-extract-plugin
export default {"side-toolbar-tools":"SideToolbar_side-toolbar-tools__TPFSv"};